import { request } from '../request'

/**
 * 关注列表
 * @param condition
 * @returns {AxiosPromise}
 */
export function getAttentionList(condition) {
    return request({
        url: "/agg-portal/ap/member/attention/list",
        method: 'get',
        params: condition
    });
}

/**
 * 获取用户收货地址列表
 */
export function getUserAddressList() {
    return request({
        url: "/agg-portal/ap/member/address/list",
        method: 'get',
    });
}

/**
 * 获取用户地址详情
 * @param id
 * @returns {AxiosPromise}
 */
export function getUserAddressDetail(id) {
    return request({
        url: "/agg-portal/ap/member/address/" + id,
        method: 'get',
    });
}

/**
 * 修改收货地址
 * @param data
 * @returns {AxiosPromise}
 */
export function updateUserAddress(data) {
    return request({
        url: "/agg-portal/ap/member/address/update/" + data.id,
        method: 'post',
        data: data
    });
}

/**
 * 添加收货地址
 * @param data
 * @returns {AxiosPromise}
 */
export function addUserAddress(data) {
    return request({
        url: "/agg-portal/ap/member/address/add",
        method: 'post',
        data: data
    });
}

/**
 * 删除收货地址
 * @param id
 * @returns {AxiosPromise}
 */
export function delUserAddress(id) {
    return request({
        url: "/agg-portal/ap/member/address/delete/"+id,
        method: 'post',
    });
}

/**
 * 获取会员信息列表
 * @returns {AxiosPromise}
 */
export function getUserInfor(userId) {
    return request({
        url: "/agg-portal/ap/sso/userInfor?userId="+userId,
        method:'get'
    });
}//end


/**
 * 提交修改信息
 * @returns {AxiosPromise}
 */
export function updateUserMessage(data) {
    return request({
        url: "/agg-portal/ap/sso/updateUserMessage",
        method:'POST',
        data:data
    });
}//end


/**
 * 提交修改头像信息
 * @returns {AxiosPromise}
 */
export function UpdateFile(data) {
    return request({
        url: "/agg-portal/ap/sso/updateFile",
        method:'POST',
        data:data,
        headers:{
            "Content-Type":"multipart/form-data"
        }
    });
}//end

/**
 * 获取头像的信息
 * @returns {AxiosPromise}
 */
export function UpdataUserPay(data) {
    return request({
        url: "/agg-portal/ap/sso/updataUserPay",
        method:'POST',
        params:data,
    });
}//end


/**
 * 提交修改支付密码的信息
 * @returns {AxiosPromise}
 */
export function UpdataUserPay2() {
    return request({
        url: "/agg-portal/ap/sso/getUserIcon",
        method:'POST',
    });
}//end


/**
 * 获取用户的头像
 * @returns {AxiosPromise}
 */
export function getUserIcon() {
    return request({
        url: "/agg-portal/ap/sso/getUserIcon",
        method:'POST',
    });
}//end


/**
 * 获取用户选择的 lang
 * @returns {AxiosPromise}
 */
export function getLang() {
    return request({
        url: "/agg-portal/ap/sso/getLang",
        method:'GET',
    });
}//end

export function setLang(lang) {
    return request({
        url: "/agg-portal/ap/sso/setLang",
        method:'GET',
        params:{
            lang:lang
        }
    });
}//end


